<div class="empty-container">
  <div class="empty-content">
    <div class="empty-icon-circle">
      <i class="pi pi-inbox empty-icon"></i>
    </div>

    <div class="empty-text">
      <p class="empty-title">{{ 'noEntriesYet' | translate }}</p>
      <p class="empty-subtitle">{{ 'createEntriesToDisplayHere' | translate }}</p>
    </div>
  </div>
</div>
